/**
 * The old link or the new link the customer needs. The option labels and the text under them live here and nowhere else, so
 * the real wording (and any URL) is changed in this one constant.
 */
export type LinkVersion = 'old' | 'new'

export interface LinkVersionOption {
  value: LinkVersion
  label: string
  /** The text under the label. Placeholder wording until the real text (and any URL) is supplied. */
  description: string
}

export const LINK_VERSION_QUESTION = 'Does the customer need the old link or the new link?'

export const LINK_VERSION_OPTIONS: readonly LinkVersionOption[] = Object.freeze([
  { value: 'old', label: 'Old link', description: 'The customer keeps using the existing link.' },
  { value: 'new', label: 'New link', description: 'The customer is given the new link.' },
] as const)

export function linkVersionLabel(value: LinkVersion): string {
  return LINK_VERSION_OPTIONS.find((option) => option.value === value)?.label ?? value
}
